import { render, staticRenderFns } from "./contentCourseRecycle.vue?vue&type=template&id=997cdfe8&"
import script from "./contentCourseRecycle.vue?vue&type=script&lang=js&"
export * from "./contentCourseRecycle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports